import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from '@reach/router';
import Button from '@material-ui/core/Button';
import { Slices, Redux } from 'spwa-ui-library';
// LOCAL IMPORT
import css from './index.module.scss';
import myFavIcon from './favorite.svg';
import heartIcon from './heart.svg';
import { Context } from '../../components/Multi-lang/Wrapper';

const { useSelector } = Redux;
const { selectAllMain } = Slices.categorySlice;

const MyFavorites = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const categories = useSelector(selectAllMain);
  const result = categories?.sort((a, b) => a.position - b.position);
  const context = useContext(Context);
  const URLEncode = (inputSrc) => encodeURI(inputSrc?.toLowerCase()?.replace(/\s/g, '-'));
  const exploreMenuPath = `/${context?.locale}/${URLEncode(result[0]?.name)}/${result[0]?.id}`;
  const pizzaText = intl.formatMessage({ id: 'pizzaText' });
  const favoriteText = intl.formatMessage({ id: 'favoriteText' });
  const heartText = intl.formatMessage({ id: 'heartText' });
  const exploreMenu = (e) => {
    e.preventDefault();
    navigate(exploreMenuPath);
  };
  return (
    <div className={css.favtCat}>
      <img src={myFavIcon} width="180" alt="No Favourite Item" />
      <div className={css.textWrap}>
        <p className={css.textStylePizza}>{pizzaText}</p>
        <div className={css.favoriteContainer}>
          <p className={css.textStyle}>{favoriteText}</p>
          <img src={heartIcon} alt="Heart" className={css.heartIcon} />
          <p className={css.textStyle}>{heartText}</p>
        </div>
      </div>
      <Button variant="contained" color="primary" size="medium" onClick={exploreMenu}>
        <FormattedMessage id="explore_menu" defaultMessage="Explore  Menu" />
      </Button>
    </div>
  );
};

export default MyFavorites;
